import React, {useState, useEffect} from 'react';
import AlgorithmsDetails from '../AlgorithmsDetails/AlgorithmsDetails';
import AlgoritmsScreenDetailsEnd from "../oldAlgorithmsDetails/alogrithmsDetails";
import styles from './App.module.css';

function App() {

    const [data, setData] = useState([])

    useEffect(async () => {
        const res = await fetch(`${window.location.origin}/wp-json/webalgos/getalgo?password=wildgeese&id=${window.webalgo_json}`)
        // const res = await fetch(`http://karat-expert.ru/wp-json/webalgos/getalgo?password=wildgeese&id=1790`)
            .then(res => res.json());
        // setData((JSON.parse(res.data)[0].result !== undefined||JSON.parse(res.data)[0].answers !== undefined))
        setData(JSON.parse(res.data))
    },[]);

    return (
        <div className={styles.wrap}>
            {(data[0] !== undefined &&(data[0].result !== undefined||data[0].answers !== undefined)) === true ?
                <AlgoritmsScreenDetailsEnd/>
            :
                <AlgorithmsDetails/>}
        </div>
    );
}

export default App;
